const shopify = {
  inputCustomerName: 'Nombre',
  inputCardExpiryDate: 'Fecha de Vencimiento',
  inputCardSecurityCode: 'Código de Seguridad',
};


module.exports = shopify;
